import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { take, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { AUTH_STATE } from '../tokens/auth-state.token';
import { GET_USER_STATUS } from '../tokens/user-status.token';
import { computeEffectiveStatus } from '../models/user-status.model';
import { foreignRoleRedirect } from './role-areas';

/**
 * Guards /wallet: requires an authenticated socio with effective status "approved".
 * - Anonymous users → /
 * - Managers → /manager
 * - Socios with any status other than "approved" → /home
 * - Approved socios → allow
 */
export const walletGuard: CanActivateFn = () => {
  const authState$ = inject(AUTH_STATE);
  const getUserStatus = inject(GET_USER_STATUS);
  const router = inject(Router);

  return authState$.pipe(
    take(1),
    switchMap((user) => {
      if (!user) return [router.createUrlTree(['/'])];
      return getUserStatus(user.uid).pipe(
        map((status) => {
          if (!status) return router.createUrlTree(['/home']);
          const away = foreignRoleRedirect(router, status.role, ['socio']);
          if (away) return away;
          const effective = computeEffectiveStatus(
            status.registrationStatus,
            user.emailVerified,
          );
          if (effective !== 'approved') {
            return router.createUrlTree(['/home']);
          }
          return true;
        }),
      );
    }),
  );
};
